import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import accordionopen from '../../assets/accordionopen.svg';
import bannerImage from '../../assets/main-banner.png';
import sponsorBanner from '../../assets/sponsor-banner.png';
import stallBanner from '../../assets/stall-banner.png';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import DialogComponent from '../../components/DialogComponent/DialogComponent';
import DropdownComponent from '../../components/DropdownComponent/DropdownComponent';
import CounterInputComponent from '../../components/InputComponent/CounterInputComponent';
import InputComponent from '../../components/InputComponent/InputComponent';
import MobileInputComponent from '../../components/InputComponent/MobileInputComponent';
import LoaderComponent from '../../components/LoaderComponent/LoaderComponent';
import NotificationComponent from '../../components/NotificationComponent/NotificationComponent';
import RadioboxComponent from '../../components/RadioboxComponent/RadioboxComponent';
import { addTicketEnquiry, addTicketIssue, changePromoPassword, getAboutEvent, getEventList, getEventTicketRate, getImagesList, GetPromoCode, GetPromoCodeFromURL, validatePromoCode, verifyPayment } from '../../services/apiController';
import { setEventMasterId } from '../../store/reduxMasterSlice';
import { countryCodeOptions } from '../../utils/countryCodeOptions';
import './BookingPage.css'; // Import the custom CSS file

import ImageCarousel from '../../components/CustomSliderComponent/ImageCarousel';
import ChatBotWidget from '../../components/ChatBotWidget/ChatBotWidget';
import ticksquare from "../../assets/tick-square.svg";
import StripeCheckoutForm from '../../components/StripeCheckoutForm/StripeCheckoutForm';

const images = [
    bannerImage,
    stallBanner,
    sponsorBanner
];

const accordionData1 = [
    {
        title: 'About This Event',
        content: ""
    },
    {
        title: 'Frequently Ask Questions',
        content: ""
    },
    {
        title: 'Terms & Conditions',
        content: ""
    }
];

const getCurrencySymbol = (currencyCode) => `${currencyCode || 'INR'} `;

const getCurrencyFormatter = (currencyCode) => new Intl.NumberFormat(
    currencyCode === 'INR' ? 'en-IN' : 'en-US',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
);

const paymentMethods = [
    {
        id: "card",
        label: "Credit / Debit Card Payment",
    },
    {
        id: "applePay",
        label: "Apple Pay",
    },
    {
        id: "googlePay",
        label: "Google Pay",
    },
    // {
    //     id: "cashApp",
    //     label: "Cash App Pay",
    // },
];

const BookingPage = () => {

    const dispatch = useDispatch();
    const eventMasterId = useSelector(state => state.reduxMaster.eventMasterId);

    const params = new URLSearchParams(window.location.search);
    const promo = params.get("prcd");

    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);

    const minTicketsCount = 1
    const maxTicketsCount = 20

    const [imagesData, setImagesData] = useState({});
    const [ticketsData, setticketsData] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedTicketType, setSelectedTicketType] = useState(null);
    const [promoCodeId, setPromoCodeId] = useState(0);
    const [promoFieldDisable, setPromoFieldDisable] = useState(false);
    const [increaseDecrease, setIncreaseDecrease] = useState(false);
    const [tempTicketCount, setTempTicketCount] = useState(1);

    const [passswordPopupOpen, setPassswordPopupOpen] = useState(false);
    const [paymentPopupOpen, setPaymentPopupOpen] = useState(false);

    const [ticketRateData, setTicketRateData] = useState([]);
    const [ticketTotalPrice, setTicketTotalPrice] = useState(0);

    const [squareCard, setSquareCard] = useState(null);
    const [squarePayments, setSquarePayments] = useState(null);

    const [squareApplePay, setSquareApplePay] = useState(null);
    const [squareGooglePay, setSquareGooglePay] = useState(null);
    const [squareCashAppPay, setSquareCashAppPay] = useState(null);

    const [squareProcessing, setSquareProcessing] = useState(false);

    const [orderID, setOrderID] = useState(null);
    const [ticketIssueID, setTicketIssueID] = useState(null);

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("card");

    const [formData, setFormData] = useState({ name: '', whatsapp: '', email: '', ticketsCount: 1, promoCode: '', promoPassword: '', selectedTicketTypeId: '' });
    const [changePasswordFormData, setChangePasswordFormData] = useState({ changePassword: '', changeConfirmPassword: '', });
    const [errors, setErrors] = useState({}); // To store validation errors

    const [accordionData, setAccordionData] = useState(accordionData1);

    // State to manage snackbar visibility and messages
    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' });
    const handleCloseSnackbar = () => {
        setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' });
    };

    const isIndiaEvent = selectedEvent?.Country?.trim()?.toLowerCase() === "india";

    const isSquarePayment = !isIndiaEvent;

    useEffect(() => {
        // fetch('https://ipapi.co/json/')
        //     .then((res) => res.json())
        //     .then((data) => {
        //         console.log('data:', data)
        //         // setLocationInfo({
        //         //     country: data.country_name,      // e.g., "United States"
        //         //     currency: data.currency,          // e.g., "USD"
        //         //     currencyName: data.currency_name, // e.g., "Dollar"
        //         // });
        //         // setLoading(false);
        //     })
        //     .catch((error) => {
        //         console.error('Error fetching data:', error);
        //         // setLoading(false);
        //     });

        wsGetEventData();
    }, []);

    useEffect(() => {
        if (!paymentPopupOpen) return;

        const country =
            selectedEvent?.Country?.trim()?.toLowerCase();

        // India uses Razorpay
        if (country === "india") {
            return;
        }

        // Other countries use Square
        initializePaymentMethod(selectedPaymentMethod);

    }, [paymentPopupOpen, selectedPaymentMethod, selectedEvent, ticketTotalPrice, ticketIssueID,]);

    const wsGetEventData = () => {
        setLoading(true);

        getEventList().then((response) => {
            const ticketsData = response?.tickets || [];

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const filteredTickets = ticketsData.filter((ticket) => {
                const eventDate = new Date(ticket.EventDate);
                eventDate.setHours(0, 0, 0, 0);

                const isClosed = ticket.EventClose === 1;
                const isPostponed = ticket.EventPostpone === 1;
                const isPreviousDate = eventDate < today;

                return !isClosed && !isPostponed && !isPreviousDate;
            });

            setticketsData(filteredTickets);

            selectDefaultEvent({
                tickets: filteredTickets
            });

        }).catch((error) => {
            setLoading(false);
        });
    };

    const selectDefaultEvent = (ticketsData) => {
        wsGetImagesList(ticketsData.tickets[0].TicketMasterId);
        if (ticketsData.tickets.length === 1) {
            setSelectedEvent(ticketsData.tickets[0]);
            dispatch(setEventMasterId(ticketsData.tickets[0].TicketMasterId));

            if (promo) {
                wsGetPromoCodeFromURL(promo);
            } else {
                wsGetEventTicketRate(ticketsData.tickets[0].TicketMasterId, promoCodeId);
                // wsGetPromoCode(ticketsData.tickets[0].TicketMasterId);
            }

        } else {
            setLoading(false);
        }
    }

    const wsGetImagesList = (eventId) => {
        getImagesList({ ticket_master_id: eventId })
            .then((response) => {
                const imageArray = Object.values(response.images);
                setImagesData(response?.images);
                wsGetAboutEvent(eventId);
            }).catch((err) => {
                setLoading(false);
            });
    }

    const wsGetAboutEvent = (eventId) => {
        getAboutEvent({ TicketMasterId: eventId })
            .then((response) => {

                const updatedSections = accordionData1.map((item) => {
                    if (item.title === "About This Event") {
                        return { ...item, content: response.EventAboutInfo };
                    }

                    if (item.title === "Frequently Ask Questions") {
                        return { ...item, content: response.EventAboutFAQ };
                    }

                    if (item.title === "Terms & Conditions") {
                        return { ...item, content: response.EventAboutTermsConditions };
                    }

                    return item;
                });

                setAccordionData(updatedSections);

            }).catch((error) => {
                setLoading(false);
            })
    }

    const wsGetEventTicketRate = async (eventId, promoCodeId, callImage, currency) => {
        const ticketEnquiryData = {
            ticketMasterId: eventId,
            TicketPromoCodeId: promoCodeId,
        }

        const rateCurrency = currency || selectedEvent?.Currency;

        await getEventTicketRate(ticketEnquiryData)
            .then((response) => {
                const ticketRates = response.TicketRates;

                const formattedData = (ticketRates || []).map(item => ({
                    ...item,
                    id: item.TicketClassificationId,
                    value: item.MinimumTickets > 1
                        ? `${item.TicketType} ( ${item.MinimumTickets} Tickets With Round Table ) ${getCurrencySymbol(rateCurrency)}${getCurrencyFormatter(rateCurrency).format(item.TicketRate)}`
                        : `${item.TicketType} ${getCurrencySymbol(rateCurrency)}${getCurrencyFormatter(rateCurrency).format(item.TicketRate)}`,
                }));

                setTicketRateData(formattedData);
                setTicketTotalPrice(0);
                setLoading(false);
            }).catch((err) => {
                setLoading(false);
            });

        if (callImage) {
            // name: '', whatsapp: '', email: '', ticketsCount: 1,
            setFormData(prev => ({ ...prev, promoCode: '', promoPassword: '', selectedTicketTypeId: '' }));
            setSelectedTicketType(null);
            setPromoFieldDisable(false);
            setPromoCodeId(0);
            setTicketTotalPrice(0);
            wsGetImagesList(eventId);
        }
    };

    const wsGetPromoCode = (TicketMasterId) => {
        GetPromoCode({ TicketMasterId })
            .then((response) => {

                if (response.status == 1) {
                    setFormData(prev => ({
                        ...prev,
                        promoCode: response.data.PromoCode,
                        promoPassword: "new123" // set whatever password you want
                    }));
                }

                setLoading(false);
            }).catch((e) => {
                setLoading(false);
            })
    }

    const wsGetPromoCodeFromURL = (prcd) => {
        GetPromoCodeFromURL({ prcd })
            .then((response) => {
                if (response.Status == 1) {
                    setFormData(prev => ({
                        ...prev,
                        promoCode: response.PromoCode,
                        promoPassword: response.NewPassword // set whatever password you want
                    }));
                    wsGetEventTicketRate(response.TicketMasterId, response.TicketPromoCodeId);
                } else {
                    wsGetEventTicketRate(eventMasterId, promoCodeId);
                    wsGetPromoCode(eventMasterId);
                }
            }).catch((e) => {
                setLoading(false);
            })
    }

    const wsAddTicketEnquiry = () => {
        if (formData.name.trim() && formData.whatsapp.trim() && formData.email.trim()) {
            const ticketEnquiryData = {
                ticket_master_id: selectedEvent?.TicketMasterId,
                name: formData.name,
                mobile_no: formData.whatsapp,
                email_id: formData.email,
                ticket_count: formData.ticketsCount || 1,
                total_amount: ticketTotalPrice,
            };
            addTicketEnquiry(ticketEnquiryData).then((res) => { }).catch((e) => { });
        }
    }

    const wsAddTicketIssue = (infoDetails, transactionID = "") => {
        setButtonLoading(true);

        const ticketEnquiryData = {
            ticket_master_id: selectedEvent?.TicketMasterId,
            name: infoDetails.name,
            mobile_no: infoDetails.whatsapp,
            email_id: infoDetails.email,
            ticket_count: infoDetails.ticketsCount || 1,
            ticket_classification_id: infoDetails.selectedTicketTypeId,
            TicketPromoCodeId: promoCodeId,
        };

        if (transactionID == "") {
            addTicketIssue(ticketEnquiryData)
                .then((response) => {
                    setTicketIssueID(response.ticket_issue_id);
                    setOrderID(response.order_id);

                    handlePaymentPopupOpen();
                }).catch((error) => {
                    setButtonLoading(false);
                });
        } else {
            handleVerifyPayment(transactionID, ticketIssueID);
        }
    }

    const handleVerifyPayment = (transactionID, ticketIssueID, paymentMethod = "razorpay") => {
        const objectParameter = {
            razorpay_payment_id: transactionID,
            ticket_issue_id: ticketIssueID,
            TicketPromoCodeId: promoCodeId,
            payment_method: paymentMethod
        }

        handlePaymentPopupClose();
        setLoading(true);

        verifyPayment(objectParameter)
            .then((response) => {
                if (response.status == 1) {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'success' });
                    // setTimeout(() => { window.location.reload(); }, 3000);
                    setFormData({ name: '', whatsapp: '', email: '', ticketsCount: 1, promoCode: '', promoPassword: '', selectedTicketTypeId: '' });
                    setSelectedTicketType(null);
                    setPromoFieldDisable(false);
                    setPromoCodeId(0);
                    setTicketTotalPrice(0);
                    wsGetEventTicketRate(selectedEvent?.TicketMasterId, 0);
                } else {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'error' });
                }
                setLoading(false);
            }).catch((e) => {
                setLoading(false);
            })
    }

    const wsValidatePromoCode = (infoDetails) => {
        const objectParameter = {
            ticketMasterId: selectedEvent?.TicketMasterId,
            promoCode: infoDetails.promoCode,
            password: infoDetails.promoPassword,
        }
        setLoading(true);
        setPromoFieldDisable(true);

        validatePromoCode(objectParameter)
            .then((response) => {
                if (response.Status == 1) {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.Message, snackbarSeverity: 'success' });
                    setSelectedTicketType(null);
                    setFormData((prev) => ({ ...prev, ticketsCount: 1, selectedTicketTypeId: '', promoPassword: infoDetails.promoPassword }));
                    setPromoCodeId(response.TicketPromoCodeId);
                    wsGetEventTicketRate(selectedEvent?.TicketMasterId, response.TicketPromoCodeId);
                } else if (response.Status == 2) {
                    // setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.Message, snackbarSeverity: 'warning' });
                    setPromoCodeId(response.TicketPromoCodeId);
                    setPassswordPopupOpen(true);
                    setPromoFieldDisable(false);
                } else {
                    setPromoFieldDisable(false);
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.Message, snackbarSeverity: 'error' });
                }
                setLoading(false);
            }).catch((e) => {
                setPromoFieldDisable(false);
                setLoading(false);
            })
    }

    const wsChangePromoPassword = (changeConfirmPassword) => {
        const objectParameter = {
            ticketMasterId: selectedEvent?.TicketMasterId,
            TicketPromoCodeId: promoCodeId,
            NewPassword: changeConfirmPassword,
        }
        setLoading(true);

        changePromoPassword(objectParameter)
            .then((response) => {
                if (response.Status == 1) {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.Message, snackbarSeverity: 'success' });
                    setSelectedTicketType(null);
                    setFormData((prev) => ({ ...prev, ticketsCount: 1, promoCode: '', promoPassword: '', selectedTicketTypeId: '' }));
                    setPassswordPopupOpen(false);
                } else {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.Message, snackbarSeverity: 'error' });
                }
                setLoading(false);
            }).catch((e) => {
                setLoading(false);
            })
    }

    // Your existing handlers (handleChange, increment, decrement, etc.)
    const handleChange = (e, type, maxLength) => {
        const { name, value } = e.target;
        if (type === 'number') {
            // Allow only digits (0-9), and optionally + at the start
            if (/^\+?\d*$/.test(value)) {
                // Optional: Limit length (e.g., 15 digits max)
                if (value.length <= maxLength) { // + sign + 15 digits
                    setFormData((prev) => ({ ...prev, whatsapp: value }));
                    setErrors((prev) => ({ ...prev, whatsapp: '' }));
                }
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));

            // Clear error when user starts typing
            if (errors[name]) {
                setErrors((prev) => ({ ...prev, [name]: '' }));
            }
        }
    };

    const handleChangeTicketType = (selectedId) => {
        const filtered = ticketRateData.find(item => item.TicketClassificationId == selectedId);
        if (filtered) {
            setFormData((prev) => ({ ...prev, "selectedTicketTypeId": selectedId, "ticketsCount": filtered.MinimumTickets > 1 ? filtered.MinimumTickets : tempTicketCount > filtered.MinimumTickets ? 1 : formData.ticketsCount }));

            setSelectedTicketType(filtered);
            setIncreaseDecrease(filtered.MinimumTickets > 1 ? true : false)
            setTempTicketCount(filtered.MinimumTickets);
            setErrors({ selectedTicketTypeId: '' });
            updateTotalPrice(filtered.MinimumTickets > 1 ? 1 : tempTicketCount > filtered.MinimumTickets ? 1 : formData.ticketsCount, filtered.TicketRate);
        }
    }

    // Your existing handlers (handleChange, increment, decrement, etc.)
    const handleChangePasswordForm = (e) => {

        {/* changePassword: '', changeConfirmPassword: '', */ }
        const { name, value } = e.target;

        setChangePasswordFormData((prev) => ({ ...prev, [name]: value }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: '' }));
        }
    };

    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email) {
            return 'Email is required';
        }
        if (!emailRegex.test(email)) {
            return 'Please enter a valid email address';
        }
        return '';
    };

    // Update the total price whenever tickets change
    const updateTotalPrice = (newTicketCount, TicketRate) => {
        setTicketTotalPrice(newTicketCount * TicketRate);
    };

    // Increment/Decrement (safe as before)
    const increment = () => {
        if (increaseDecrease) return;
        setFormData((prev) => {
            const newTicketCount = prev.ticketsCount < maxTicketsCount ? prev.ticketsCount + 1 : maxTicketsCount;
            if (selectedTicketType !== null) { updateTotalPrice(newTicketCount, selectedTicketType.TicketRate); }
            return { ...prev, ticketsCount: newTicketCount };
        });
    };

    const decrement = () => {
        if (increaseDecrease) return;
        setFormData((prev) => {
            const newTicketCount = prev.ticketsCount > minTicketsCount ? prev.ticketsCount - 1 : minTicketsCount;
            if (selectedTicketType !== null) { updateTotalPrice(newTicketCount, selectedTicketType.TicketRate); }
            return { ...prev, ticketsCount: newTicketCount };
        });
    };

    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    // Form submission with validation
    const handleSubmit = (e) => {
        e?.preventDefault(); // Prevent default if used in <form>

        if (selectedEvent === null) { setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: 'Please select event first', snackbarSeverity: 'error' }); return; }

        // Validate other required fields (optional)
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';

        if (!formData.whatsapp.trim()) {
            newErrors.whatsapp = 'WhatsApp number is required';
        } else {
            // Find matching country code
            const country = countryCodeOptions.find(c => formData.whatsapp.startsWith(c.id));

            if (!country) {
                newErrors.whatsapp = 'Invalid country code';
            } else {
                const actualLength = formData.whatsapp.length - country.id.length;

                if (actualLength !== country.length) {
                    newErrors.whatsapp = `WhatsApp number must be ${country.length} digits`;
                }
            }
        }

        if (!formData.email.trim()) newErrors.email = 'Email is required';
        if (!formData.selectedTicketTypeId.trim()) newErrors.selectedTicketTypeId = 'Ticket type is required';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Validate email
        const emailError = validateEmail(formData.email);

        if (emailError) {
            setErrors({ email: emailError });
            return; // Stop submission
        }

        // Clear any previous errors
        setErrors({});

        // Success: Proceed with submission        
        if (ticketTotalPrice !== 0.00 || ticketTotalPrice !== 0) {
            wsAddTicketIssue(formData, "");
        } else {
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: 'Please select event first', snackbarSeverity: 'error' }); return;
        }
    };

    // Form submission with validation
    const handleApplyPromoCode = (e) => {
        e?.preventDefault(); // Prevent default if used in <form> Early Bird

        if (selectedEvent === null) { setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: 'Please select event first', snackbarSeverity: 'error' }); return; }

        const newErrors = {};
        if (!formData.promoCode.trim()) newErrors.promoCode = 'Promo Code is required';
        if (formData.promoCode !== 'Early Bird' && !formData.promoPassword.trim()) newErrors.promoPassword = 'Password is required';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Clear any previous errors
        setErrors({});

        wsValidatePromoCode(formData, "");
    }

    const handleRazorpayPayment = async () => {

        const options = {
            key: process.env.REACT_APP_RAZORPAY_KAY, // Your Razorpay key id
            amount: ticketTotalPrice * 100, // Amount in paise
            currency: "INR",
            name: "Akadeet Entertainment Private Limited",
            order_id: orderID, // The order ID you received from the server
            handler: function (response) {
                // You can send the payment response to your server here for verification                
                wsAddTicketIssue(formData, response.razorpay_payment_id);
            },
            prefill: {
                name: formData.name,
                email: formData.email,
                contact: formData.whatsapp,
            },
            theme: {
                color: "#FFF",
            },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };






    const handleApplePayPayment = async () => {
        console.log('squareApplePay:', squareApplePay)
        if (!squareApplePay) {
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Apple Pay is not ready.", snackbarSeverity: "error", });
            return;
        }

        try {
            setLoading(true);
            const tokenResult = await squareApplePay.tokenize();
            if (tokenResult.status !== "OK") {
                console.error(tokenResult);
                setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Apple Pay payment failed.", snackbarSeverity: "error", });
                setLoading(false);
                return;
            }

            const paymentToken = tokenResult.token;
            console.log("Apple Pay token:", paymentToken);
            handleVerifyPayment(paymentToken, ticketIssueID, "square");

        } catch (error) {
            console.error("Apple Pay payment failed:", error);
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Apple Pay payment failed.", snackbarSeverity: "error", });
            setLoading(false);
        }
    };

    const handleGooglePayPayment = async () => {
        if (!squareGooglePay) {
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Google Pay is not ready.", snackbarSeverity: "error", });
            return;
        }

        try {
            setLoading(true);
            const tokenResult = await squareGooglePay.tokenize();

            if (tokenResult.status !== "OK") {
                console.error(tokenResult);
                setLoading(false);
                setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Google Pay payment failed.", snackbarSeverity: "error", });
                return;
            }

            const paymentToken = tokenResult.token;
            console.log("Google Pay token:", paymentToken);
            handleVerifyPayment(paymentToken, ticketIssueID, "square");
        } catch (error) {
            console.error("Google Pay payment failed:", error);

            setLoading(false);
        }
    };


    const handlePayment = async () => {

        const country =
            selectedEvent?.Country?.trim()?.toLowerCase();

        // INDIA -> RAZORPAY
        if (country === "india") {
            handleRazorpayPayment();
            return;
        }

        // OTHER COUNTRIES -> SQUARE

        if (selectedPaymentMethod === "card") {
            await handleSquarePayment();
            return;
        }

        if (selectedPaymentMethod === "applePay") {
            await handleApplePayPayment();
            return;
        }

        if (selectedPaymentMethod === "googlePay") {
            await handleGooglePayPayment();
            return;
        }

        // Cash App handles tokenization through
        // its ontokenization event.
        if (selectedPaymentMethod === "cashApp") {
            if (!squareCashAppPay) {
                setSnackbarStates({
                    isSnackbarOpen: true,
                    snackbarMessage: "Cash App Pay is not ready.",
                    snackbarSeverity: "error",
                });
            }

            return;
        }
    };

    const handleSquarePayment = async () => {
        if (!squareCard) {
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Payment form is not ready. Please try again.", snackbarSeverity: "error", });
            return;
        }

        try {
            setSquareProcessing(true);
            setLoading(true);

            const result = await squareCard.tokenize();

            if (result.status !== "OK") {
                setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Payment failed. Please check your card details.", snackbarSeverity: "error", });

                setSquareProcessing(false);
                setLoading(false);
                return;
            }

            const paymentToken = result.token;

            handleVerifyPayment(paymentToken, ticketIssueID, "square");

        } catch (error) {
            console.error("Square payment failed:", error);
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Payment failed. Please try again.", snackbarSeverity: "error", });

            setSquareProcessing(false);
            setLoading(false);
        }
    };

    const initializePaymentMethod = async (method) => {
        if (!window.Square) {
            console.error("Square Web Payments SDK is not loaded.");
            setSnackbarStates({
                isSnackbarOpen: true,
                snackbarMessage: "Square Web Payments SDK is not loaded. Please refresh the page.",
                snackbarSeverity: "error",
            });
            return;
        }

        try {
            const applicationId = process.env.REACT_APP_SQUARE_APPLICATION_ID;
            const locationId = process.env.REACT_APP_SQUARE_LOCATION_ID;

            if (!applicationId || !locationId) {
                console.error("Square Application ID or Location ID is missing.");
                setSnackbarStates({
                    isSnackbarOpen: true,
                    snackbarMessage: "Square configuration is missing (application/location ID).",
                    snackbarSeverity: "error",
                });
                return;
            }

            const payments = window.Square.payments(applicationId, locationId);

            setSquarePayments(payments);

            // ------------------------------------
            // CARD
            // ------------------------------------
            if (method === "card") {
                if (squareCard) {
                    try {
                        await squareCard.destroy();
                    } catch (e) {
                        console.log("Old card destroy error:", e);
                    }
                }

                const card = await payments.card();
                await card.attach("#square-card-container");
                setSquareCard(card);
                return;
            }

            // ------------------------------------
            // PAYMENT REQUEST
            // ------------------------------------
            const amount = Number(ticketTotalPrice || 0).toFixed(2);

            const paymentRequest = payments.paymentRequest({
                countryCode: "US",
                currencyCode: "USD",
                total: {
                    amount: amount,
                    label: "Total",
                },
            });

            // ------------------------------------
            // APPLE PAY
            // ------------------------------------
            if (method === "applePay") {
                const applePay = await payments.applePay(paymentRequest);

                setSquareApplePay(applePay);

                /*
                 * Apple Pay renders its own payment sheet.
                 * Square's Apple Pay integration doesn't require
                 * attaching a button like Google Pay.
                 */
                return;
            }

            // ------------------------------------
            // GOOGLE PAY
            // ------------------------------------
            if (method === "googlePay") {
                const googlePay = await payments.googlePay(paymentRequest);
                // await googlePay.attach("#square-google-pay-container");
                setSquareGooglePay(googlePay);
                return;
            }

        } catch (error) {
            console.error(`Square ${method} initialization failed:`, error);
            setSnackbarStates({
                isSnackbarOpen: true,
                snackbarMessage: error?.message || `${method} setup failed.`,
                snackbarSeverity: "error",
            });
        }
    };








    const handlePassswordSave = (e) => {
        e?.preventDefault(); // Prevent default if used in <form>
        // changePassword: '', changeConfirmPassword: '', 

        const newErrors = {};
        if (!changePasswordFormData.changePassword.trim()) newErrors.changePassword = 'Password is required';
        else if (changePasswordFormData.changePassword.length < 5) newErrors.changePassword = 'Password must be at least 5 characters';
        if (!changePasswordFormData.changeConfirmPassword.trim()) newErrors.changeConfirmPassword = 'Confirm password is required';

        if (changePasswordFormData.changePassword !== changePasswordFormData.changeConfirmPassword) {
            newErrors.changeConfirmPassword = 'Passwords and Confirm password do not match';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Clear any previous errors
        setErrors({});

        wsChangePromoPassword(changePasswordFormData.changeConfirmPassword);

    }
    const handlePassswordPopupClose = () => {
        setPassswordPopupOpen(false);
        setChangePasswordFormData({ changePassword: '', changeConfirmPassword: '' });
    }

    const handlePaymentPopupOpen = () => {
        setPaymentPopupOpen(true);
    };

    const handlePaymentPopupClose = () => {
        setButtonLoading(false);
        setPaymentPopupOpen(false);
    };

    return (loading ? <LoaderComponent />
        : <React.Fragment>

            <NotificationComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />

            {/* <ChatBotWidget /> */}

            {/* <ImageCarousel images={imagesData} autoPlay={true} interval={4000} /> */}
            <img src={imagesData?.image2 || bannerImage} style={{ width: '100%' }} />

            <div className="booking-container">
                {/* Card for Ticket Form */}
                <div>
                    <h2 className="heading">Book Tickets Now</h2>
                    {/* Date Selection (Radio Button as Card) */}
                    {ticketsData.map((item, index) => {
                        const uniqueId = `event-date-${index}`;

                        return (
                            <div className="event-radio-card" key={index}>
                                <RadioboxComponent
                                    uniqueId={uniqueId}
                                    name="selectedEvent"
                                    value={item.TicketMasterId}
                                    checked={selectedEvent?.TicketMasterId === item.TicketMasterId}
                                    onChange={() => {
                                        setSelectedEvent(item);
                                        // Always start with Card when payment popup opens
                                        setSelectedPaymentMethod("card");

                                        // Clear previous Square objects
                                        setSquareCard(null);
                                        setSquarePayments(null);
                                        wsGetEventTicketRate(item.TicketMasterId, 0, true, item.Currency)
                                    }}
                                    label={<label htmlFor={uniqueId} className="event-radio-card-label">
                                        <span className="event-radio-card-text">{item.EventName}</span>
                                    </label>}
                                />
                            </div>
                        )
                    })}

                    {/* Form Inputs (Text Fields with Underline and Two Columns) */}
                    <div className="form-container">
                        <div className="form-grid">
                            <InputComponent name="name" placeholder="Name*" value={formData.name} onChange={handleChange} error={errors.name} onBlur={wsAddTicketEnquiry} />
                            <MobileInputComponent name="whatsapp" placeholder="WhatsApp No*" value={formData.whatsapp} onChange={(e) => handleChange(e, 'number', 14)} error={errors.whatsapp} onBlur={wsAddTicketEnquiry} />
                            <InputComponent name="email" type="email" placeholder="Email Id*" value={formData.email} onChange={handleChange} error={errors.email} onBlur={wsAddTicketEnquiry} />
                            <CounterInputComponent placeholder="No of Tickets*" value={formData.ticketsCount} decrement={decrement} increment={increment} />

                            <InputComponent name="promoCode" placeholder="Enter Promo Code" value={formData.promoCode} onChange={handleChange} error={errors.promoCode} disabled={promoFieldDisable} />

                            <div className="promo-row">
                                <InputComponent type='password' name="promoPassword" placeholder="Add Password" value={formData.promoPassword} onChange={handleChange} error={errors.promoPassword} disabled={promoFieldDisable} />
                                <ButtonComponent style={{ width: '30%', }} disabled={promoFieldDisable} onClick={handleApplyPromoCode}>Apply</ButtonComponent>
                            </div>

                        </div>
                        <DropdownComponent style={{ marginTop: "30px" }} name="selectedTicketTypeId" placeholder="Select Ticket Type*" value={formData.selectedTicketTypeId} onChange={(e) => handleChangeTicketType(e.target.value)} error={errors.selectedTicketTypeId} options={ticketRateData} />
                    </div>

                    <div className='order-summary'>
                        <div>
                            {ticketTotalPrice ? <>
                                <h3>{selectedEvent?.EventName}</h3>

                                <p><strong>Total Price:</strong> {getCurrencySymbol(selectedEvent?.Currency)}{getCurrencyFormatter(selectedEvent?.Currency).format(ticketTotalPrice)}</p>
                            </> : <></>}
                        </div>

                        {/* Submit Button */}
                        <ButtonComponent disabled={buttonLoading} onClick={handleSubmit}>Submit</ButtonComponent>
                    </div>
                </div>

                <div className="accordion-container">
                    {accordionData.map((item, index) => (
                        <div key={index} className={`accordion-item ${openIndex === index ? 'open' : ''}`} >
                            <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                                <span className="accordion-title">{item.title}</span>
                                <img src={accordionopen} alt='accordionopen' />
                            </div>
                            <div className="accordion-content">
                                <div className="accordion-content-inner" dangerouslySetInnerHTML={{ __html: item.content }} />
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            {paymentPopupOpen &&
                <DialogComponent
                    isOpen={paymentPopupOpen}
                    Title={`Payment`}
                    ActionText={"Pay Now"}
                    IsLoading={loading}
                    onSave={handlePayment}
                    onClose={handlePaymentPopupClose}
                >
                    <p>Payment for <strong>{selectedEvent != null && selectedEvent?.EventName}</strong></p>

                    <div style={{ display: 'grid', gridTemplateColumns: '150px 10px auto', rowGap: '6px', alignItems: 'center' }} >
                        <span>Price Per Ticket</span>
                        <span>:</span>
                        <strong>{getCurrencySymbol(selectedEvent?.Currency)}{getCurrencyFormatter(selectedEvent?.Currency).format(selectedTicketType?.TicketRate)}</strong>

                        <span>Total Ticket(s)</span>
                        <span>:</span>
                        <strong>{formData.ticketsCount}</strong>

                        <span>Total Amount</span>
                        <span>:</span>
                        <strong>{getCurrencySymbol(selectedEvent?.Currency)}{getCurrencyFormatter(selectedEvent?.Currency).format(ticketTotalPrice)}</strong>
                    </div>


                    {selectedEvent?.Country?.trim()?.toLowerCase() !== "india"
                        && <>
                            {paymentMethods.map((method) => (
                                <div key={method.id} className="payment-method-option">
                                    <RadioboxComponent
                                        uniqueId={`payment-${method.id}`}
                                        name="paymentMethod"
                                        value={method.id}
                                        checked={selectedPaymentMethod === method.id}
                                        onChange={() => setSelectedPaymentMethod(method.id)}
                                        label={
                                            <label htmlFor={`payment-${method.id}`} className="event-radio-card-label">
                                                <span className="event-radio-card-text">{method.label}</span>
                                            </label>
                                        }
                                    />

                                    {selectedPaymentMethod === method.id && (
                                        <div className={`payment-action payment-action-${method.id}`}>

                                            {method.id === "card" && (
                                                <div id="square-card-container"></div>
                                            )}

                                            {method.id === "applePay" && (
                                                <div id="square-apple-pay-container"></div>
                                            )}

                                            {method.id === "googlePay" && (
                                                <div id="square-google-pay-container" />
                                            )}
                                            {/* 
                                            {method.id === "cashApp" && (
                                                <div id="square-cash-app-container" className="pay-btn-container" />
                                            )} */}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </>
                    }

                    <p style={{ fontSize: '13px' }}><strong>Note :</strong></p>
                    <p style={{ marginBlock: '0', fontSize: '12px' }}>
                        Ticket once booked can't be Exchanged, Cancelled or Refunded.<br />
                        Ticket Will be issued via Email or Whatsapp</p>

                </DialogComponent>
            }

            <DialogComponent
                isOpen={passswordPopupOpen}
                Title={`Change Password`}
                ActionText={"Update"}
                IsLoading={loading}
                onSave={handlePassswordSave}
                onClose={handlePassswordPopupClose}
            >

                <form onSubmit={handleSubmit}>
                    {/* changePassword: '', changeConfirmPassword: '', */}
                    <InputComponent name="changePassword" placeholder="Password" value={changePasswordFormData.changePassword} onChange={handleChangePasswordForm} error={errors.changePassword} maxLength={25} type="password" /><br />
                    <InputComponent name="changeConfirmPassword" placeholder="Confirm Password" value={changePasswordFormData.changeConfirmPassword} onChange={handleChangePasswordForm} error={errors.changeConfirmPassword} maxLength={25} type="password" /><br />

                    <button type="submit" style={{ display: "none" }} />
                </form>

            </DialogComponent>


        </React.Fragment>
    );
};

export default BookingPage;
